import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { Petitum } from '../../../models/petitum';
import { SezioneEconomica } from '../../../models/sezioni/sezione-economica';
import { SezioneEconomicaAltriImportiEditComponent } from './sezione-economica-altri-importi-edit.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [sezione-economica-mod-altri-importi-edit]',
  templateUrl: 'sezione-economica-mod-altri-importi-edit.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class SezioneEconomicaModAltriImportiEditComponent {
  @Output() onReturn: EventEmitter<SezioneEconomica> = new EventEmitter<SezioneEconomica>();
  @ViewChild('formAltriImporti') formAltriImporti: SezioneEconomicaAltriImportiEditComponent;

  inizializza(sezione: SezioneEconomica, petitum: Petitum, urlUpdate: string) {
    this.formAltriImporti.inizializza(sezione, petitum, urlUpdate);
    openModal('modaleAltriImportiEdit');
  }

  createForm() {
    this.formAltriImporti.createForm();
  }

  manageModal(sezioneEconomica: SezioneEconomica) {
      closeModal('modaleAltriImportiEdit');
      this.onReturn.emit(sezioneEconomica);
  }
}
